import { render, staticRenderFns } from "./TrapezSSR.vue?vue&type=template&id=76757a20&"
import script from "./TrapezSSR.vue?vue&type=script&lang=js&"
export * from "./TrapezSSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports